const supportedBrands = ["storesync", "autorepair", "repairnest"];

export const resolveRequestBrand = (hostname, currentBrand) => {
  const host = String(hostname || "").toLowerCase();
  if (host.includes("storesyncpos")) return "storesync";
  if (host.includes("autorepairdesk")) return "autorepair";
  if (host.includes("repairnestpos")) return "repairnest";

  return supportedBrands.includes(currentBrand) ? currentBrand : null;
};

export const brandRequestConfig = currentBrand => {
  const brand = resolveRequestBrand(window.location.hostname, currentBrand);
  return brand ? { headers: { "x-client-brand": brand } } : {};
};
